import { FileText, Link2, Paperclip, type LucideIcon } from 'lucide-react';
import { ConsentType } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.ts';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { plainEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';

export const consentTypeLabels: Record<ConsentType, string> = {
  [ConsentType.TEMPLATE]: 'Szablon',
  [ConsentType.LINK]: 'Link',
  [ConsentType.FILE]: 'Plik',
};

export const consentTypeTableConfig: EnumTableConfig = Object.fromEntries(
  Object.values(ConsentType).map((type) => [
    type,
    plainEnumConfig(consentTypeLabels[type]),
  ]),
);

export const getConsentTypeLabel = (type: string): string => {
  return consentTypeLabels[type as ConsentType] ?? type;
};

export interface ConsentTypeChoice {
  value: ConsentType;
  label: string;
  description: string;
  icon: LucideIcon;
}

/**
 * Rodzaj zgody wybiera się raz, przy tworzeniu — backend odrzuca zmianę typu
 * istniejącego szablonu (`Cannot change consent template type`). Dlatego wybór
 * dostaje własny krok z wyjaśnieniem, czym każdy rodzaj jest w praktyce.
 */
export const consentTypeChoices: readonly ConsentTypeChoice[] = [
  {
    value: ConsentType.TEMPLATE,
    label: consentTypeLabels[ConsentType.TEMPLATE],
    description:
      'Treść piszesz w Campdesku. Możesz wstawiać zmienne, np. nazwę wyjazdu albo dane uczestnika.',
    icon: FileText,
  },
  {
    value: ConsentType.LINK,
    label: consentTypeLabels[ConsentType.LINK],
    description:
      'Podajesz adres dokumentu, który stoi już na Twojej stronie. Uczestnik otwiera go w nowej karcie.',
    icon: Link2,
  },
  {
    value: ConsentType.FILE,
    label: consentTypeLabels[ConsentType.FILE],
    description:
      'Wgrywasz gotowy plik PDF. Uczestnik pobiera go przy zapisie na wyjazd.',
    icon: Paperclip,
  },
];
